export default __webpack_public_path__ + "static/media/logo-loader-2.090ca05c.svg";